if (!customElements.get("op-algolia-accessories")) {
    customElements.define("op-algolia-accessories", class extends OpAlgoliaUtilities {
        constructor() {
            super();
            this.hitsPerPage = 3;
            this.cartProdVariants = [];
            this.hits = [];
            this.productCards = [];
            this.unsubscribeCartUpdate = null;
            this.swiper = null;
            this.swiperWrapper = this.querySelector(".swiper-wrapper");
            this.swiperPagination = this.querySelector("[data-pagination]");
            this.sliderClass = this.dataset.sliderClass
            this.type = this.dataset.type || false
            this.isMobile = this.dataset.mobile && this.dataset.mobile == 'true' ? true : false
            this.container = this.dataset.container ? this.closest('.' + this.dataset.container) : null;
            this.cartSection = document.getElementById('main-cart-items')?.dataset.id;
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.drawerFooterContainer = document.querySelector('.drawer__footer');
            this.accessoriesContainer = document.querySelector('.cart-drawer__algolia-accessories--mobile');
            this.drawerFooterContainerState = false
            this.deferInitialLoad = false;
            this.hasMounted = false;
            this.isLoading = false;
            this.lastLoadedVariants = "";
        }

        static get observedAttributes() {
            return ["cart-product-variants"];
        }

        connectedCallback() {
            this.deferInitialLoad = Boolean(this.closest('cart-drawer, cart-notification'));

            if (window.Swiper && !this.type) {
                this.swiper = new window.Swiper(this.querySelector('.'+ this.sliderClass), {
                    slidesPerView: 1,
                    loop: false,
                    spaceBetween: 8,
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true,
                        bulletClass: this.dataset.bulletClass,
                        bulletActiveClass: this.dataset.bulletActiveClass
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 1.7
                        },
                        1024: {
                            slidesPerView: 2
                        },
                        1280: {
                            slidesPerView: 3
                        }
                    }
                });
            }


            this.unsubscribeCartUpdate = this.subscribeToCartUpdate((event) => {
                const cartVariants = this.getCartVariantsFromUpdateEvent(event);

                if (cartVariants !== null) {
                    this.setAttribute("cart-product-variants", cartVariants);
                }
            });

            // Remove session data when change country
            /* subscribe("change-country", () => {
                sessionStorage.removeItem('algolia_accessories')
            }); */

            this.hasMounted = true;

            if (!this.deferInitialLoad && this.matchesCurrentViewport()) {
                this.loadAccessoriesAndMark();
            }

        }

        checkIsDesktop() {
            return window.matchMedia('(min-width: 1024px)').matches
        }

        getCartVariantsFromUpdateEvent (event) {
            const items = event?.cartData?.items;

            if (Array.isArray(items)) {
                return Array.from(
                    new Set(
                        items
                            .map(item => item?.variant_id ?? item?.id)
                            .filter(Boolean)
                            .map(String)
                    )
                ).join(",");
            }

            const updatedVariantId = event?.productVariantId ?? event?.variantId;

            if (!updatedVariantId) {
                return null;
            }

            return Array.from(
                new Set([
                    ...this.cartProdVariants.map(String),
                    String(updatedVariantId),
                ])
            ).join(",");
        }

        disconnectedCallback() {
            this.swiper?.destroy();

            if (typeof this.unsubscribeCartUpdate === "function") {
                this.unsubscribeCartUpdate();
            }
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) {
                return;
            }
            if (name == "cart-product-variants") {
                this.cartProdVariants = newValue ? newValue.split(",") : [];

                if (this.hasMounted && this.matchesCurrentViewport()) {
                    const variantsSignature = this.cartProdVariants.join(",");

                    if (!this.deferInitialLoad || variantsSignature !== this.lastLoadedVariants) {
                        this.loadAccessoriesAndMark();
                    }
                }
            }
        }

        matchesCurrentViewport() {
            return (this.checkIsDesktop() && !this.isMobile) || (!this.checkIsDesktop() && this.isMobile);
        }

        async loadAccessoriesAndMark () {
            if (this.isLoading || !this.matchesCurrentViewport()) {
                return;
            }

            this.isLoading = true;

            try {
                await this.loadAccessories();
                this.lastLoadedVariants = this.cartProdVariants.join(",");
                this.toggleAttribute("data-loaded", true);
            } finally {
                this.isLoading = false;
            }
        }

        clearProductCards () {
            if (this.productCards?.length > 0 ) {
                this.swiper?.removeAllSlides();
                this.productCards.forEach(card => card.remove());
                this.productCards.length = 0;
                this.hits.length = 0;
            }
        }

        fetchAccessories(indexName) {
    
            const algoliaApiKey = algoliaShopify.config.search_api_key;
            const algoliaAppId = algoliaShopify.config.app_id;
            
            const url = `https://${algoliaAppId}-dsn.algolia.net/1/indexes/*/queries`;
            const params = new URLSearchParams({
                "x-algolia-api-key": algoliaApiKey,
                "x-algolia-application-id": algoliaAppId
            });

            const body = JSON.stringify({
                requests: [
                    {
                        indexName: indexName,
                        params: `hitsPerPage=${this.hitsPerPage}&ruleContexts=CART&distinct=true`
                    }
                ]
            });

            return fetch(`${url}?${params.toString()}`, {
                body: body,
                method: "POST",
            })
            .then(response => response.json())
            .then(data => {
                return data;
            })
            .catch(error => {
                console.error('Error:', error);
                throw error;
            });
            
        }

        async loadAccessories () {
            /*if(sessionStorage.getItem('algolia_accessories') !== null) {
                const algoliAccessories = sessionStorage.getItem('algolia_accessories')
                const accessories = JSON.parse(algoliAccessories)
                this.updateProductCards(accessories);
                this.toggleAttribute("data-loaded", true);
                return;
            }*/
            
            try {
                const data = await this.fetchAccessories(
                    this.productsIndex);
    
                if (data?.results) {
                    const algoliaResults = JSON.stringify(data.results)
                    //sessionStorage.setItem('algolia_accessories', algoliaResults)
                    this.updateProductCards(data.results);
                }
            }
            catch (error) {
                console.error('Error fetching related products:', error);
            }

            if (this.productCards.length === 0 || this.cartProdVariants.length === 0) {
                this.clearProductCards();
            }

            this.toggleSectionEmpty(this.hits.length === 0);

        }

        parseDatasetHandles (rawHandles = "") {
            const handles = [];

            rawHandles?.split(",").forEach(handle => {
                handle = handle.trim();
                
                if (handle !== "") {
                    handles.push(handle);
                }
            });

            return handles;
        }

        toggleSectionEmpty (status) {
            this.toggleAttribute("data-empty", status);
            this.setSectionHidden(status);
        }

        updateProductCards (results = []) {
            const objIDs = new Set();
            const cardPromises = [];

            this.hits.length = 0;
            
            this.clearProductCards();

            results.some(async result => {
                const resultHits = result.hits || [];

                for (let hit of resultHits) {
                    
                    if (hit.handle && !this.cartProdVariants.includes(hit.objectID) && !objIDs.has(hit.objectID)) {
                        if (hit.inventory_available) {
                            this.hits.push(hit);
                            objIDs.add(hit.objectID);
                            const data = await this.addProductCard(hit)
                            cardPromises.push(data);
                        }
                    }
                }

                return false;
            });

            return Promise.allSettled(cardPromises);
        }


        async addProductCard(hit) {
            let productCardUrl = `${window.Shopify.routes.root}products/${hit.handle}?view=accessory-card`
            
            if(this.type == 'grid') {
                productCardUrl = productCardUrl + '&type=horizontal'
            }

            try {
                const response = await fetch(productCardUrl);
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
      
                const text = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                const cardElement = doc.querySelector(".op-cart-items-rich-product-card");

                if (!cardElement) {
                    throw new Error(`Product card not found in ${productCardUrl}`);
                }

                if (typeof hit.trackSearchAttribution === "function") {
                    cardElement.addEventListener("click", () => {
                        hit.trackSearchAttribution();
                    });
                }

                const addToCartBtn = cardElement.querySelector('.js-accessory-atc');

                
                addToCartBtn.addEventListener('click', (event) => {
                    this.addVariant(event.target);
                    const clonedDrawerFooter = this.clonedDrawerFooterContainer();
                    if (clonedDrawerFooter) {
                        clonedDrawerFooter.classList.add('tw-op-drawer-sticky-cta');
                    }
                    setTimeout(() => {
                        document.querySelector('.drawer__inner')?.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    }, 200)
                });
            

                this.appendSlide(cardElement.children[0]);
                
                
            } catch (error) {
                console.error('Error fetching product card:', error);
            }
        }

        appendSlide (element) {
            if(this.type == 'grid') {
                this.elementWrapper = document.createElement("div");
                this.elementWrapper.classList.add("accessories-wrapper");
                this.append(this.elementWrapper);
                this.elementWrapper.append(element);
            } else {
                if (!this.swiperWrapper) {
                    this.swiperWrapper = document.createElement("div");
                    this.swiperWrapper.classList.add("swiper-wrapper");
                    this.prepend(this.swiperWrapper);
                }

                if (this.swiper) {
                    element.classList.add("swiper-slide");
                    this.swiper.appendSlide(element);
                } else {
                    this.append(element);
                
                    this.swiperWrapper?.style.setProperty("display", "none");
                    this.swiperPagination?.style.setProperty("display", "none");
                }
            }

            // remove all btn "notify me "
            element.querySelectorAll('.restock-alerts-notify-button').forEach(btn => btn.remove());
            // Observe after element construction - notify me insert element after construction
            const observer = new MutationObserver(() => {
                element.querySelectorAll('.restock-alerts-notify-button').forEach(btn => btn.remove());
            });
            observer.observe(element, { childList: true, subtree: true }); 
            
            this.productCards.push(element);
        }

        setSectionHidden (status) {
            if (!this.container) return;
            status ? this.container.style.setProperty("display", "none") : this.container.style.removeProperty("display");
        }

        subscribeToCartUpdate (callback) {
            const cartUpdateEvent = typeof PUB_SUB_EVENTS !== "undefined" ? PUB_SUB_EVENTS?.cartUpdate : null;
            return typeof window.subscribe === "function" ? window.subscribe(cartUpdateEvent || "cart-update", callback) : null;
        }

        async addVariant(button) {
            const variantId = button.getAttribute('data-var-id');
            
            // add to cart
            let formData = {
                'id': variantId,
                'quantity': 1,
                'properties': {
                    '_cart_added_at': Date.now()
                }
            };
        
        try {
            let url_fetch = window.Shopify.routes.root + 'cart/add.js';
            if (this.closest('cart-drawer')) {
                
                url_fetch = url_fetch + '?sections=cart-drawer,cart-icon-bubble,op-cart-drawer-product,cart-notification-product';
            }

            const response = await fetch(url_fetch, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
                });
                const responseData = await response.json();
                if (response.ok) {
                    if (this.closest('cart-drawer')) {
                        this.cart = document.querySelector('cart-drawer');
                        this.cart.classList.remove('is-empty');
                        this.cart.renderContents({
                            id: responseData.id,
                            sections: responseData.sections,
                        });
                        this.cart.classList.add('active', 'animate');
                        
                        
                    } else {
                        button.disabled = false;
                        this.updateCartItems();
                    }
                    // Update Accessories
                    if(this.type == 'grid') {
                        const accessoryCard = button.closest('.accessories-wrapper');
                        if (accessoryCard) accessoryCard.remove();
                    } else {
                        const accessoryCard = button.closest('op-discount-ninja-price');
                        const swiperSlider = button.closest('.swiper-slide');
                        if (accessoryCard) accessoryCard.remove();
                        if (swiperSlider) swiperSlider.remove();
                        if(this.swiper) this.swiper.update();
                    }
                    const nrOfCards = this.type == 'grid'? this.children.length : this.swiperWrapper.children.length;
                    this.toggleSectionEmpty(nrOfCards === 0)

                } else {
                    console.log('Error:', responseData.message);
                }
                if (this.closest('cart-drawer')) {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: variantId,
                        productHandle: this.dataset.productHandle,
                        cartData: responseData
                    });
                } 
            } catch (error) {
            console.error('Error:', error);
            }
        }

        updateCartItems = () => {
            fetch(`${window.location.pathname}?section_id=${this.cartSection}`)
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const cartItems = doc.querySelector('.js-main-cart-items');
                    const summary = doc.querySelector(".summary_subtotal");
                    if (cartItems) document.querySelector('.js-main-cart-items').innerHTML = cartItems.innerHTML;
                    if (summary) document.querySelector(".summary_subtotal").innerHTML = summary.innerHTML;
                    // console.log('Utility start');
                    // Call the utility function to manage child line price when an accessory is added to cart
                    UtilityUpdateLensPrice.processChildLines();
                })
                .catch(err => console.error('Failed to load section:', err));
        }

        clonedDrawerFooterContainer() {
            if (this.drawerFooterContainerState || !this.accessoriesContainer) return;

            const clone = this.drawerFooterContainer.cloneNode(true);
            this.drawerFooterContainer.classList.add('tw-hidden', 'op-tablet-md:tw-block');
            clone.classList.add('tw-bg-white');
            this.accessoriesContainer.insertAdjacentElement('beforeend', clone);

            this.drawerFooterContainerState = true;
            return clone
        }

    });
}
